import { getI18nInstance } from '@/i18n';
import { ROLES } from '@/models/User';

import RequestedUserIndex from /* webpackChunkName: "admin" */ '@/views/auth/requested_user/index.vue';
import RequestedUserEdit from /* webpackChunkName: "admin" */ '@/views/auth/requested_user/_id.vue';
import RequestedUserUserData from /* webpackChunkName: "admin" */ '@/views/auth/requested_user/_id/UserData.vue';
import RequestedUserOrganizerData from /* webpackChunkName: "admin" */ '@/views/auth/requested_user/_id/OrganizerData.vue';
import RequestedUserContactData from /* webpackChunkName: "admin" */ '@/views/auth/requested_user/_id/ContactData.vue';

export default [
    {
        path: '/requested_user',
        name: 'requested_user',
        component: RequestedUserIndex,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('requested_user'),
        },
    },
    {
        path: '/requested_user/:id',
        component: RequestedUserEdit,
        meta: {
            requiresAuth: true,
            roles: [ROLES.ADMIN],
            title: () => getI18nInstance().t('requested_user'),
        },
        children: [
            {
                path: '/',
                name: 'requested_user_edit',
                component: RequestedUserUserData,
            },
            {
                path: 'organizer_data',
                name: 'requested_user_edit_organizer',
                component: RequestedUserOrganizerData,
            },
            {
                path: 'contact_data',
                name: 'requested_user_edit_contact',
                component: RequestedUserContactData,
            },
        ],
    },
];
